/* eslint-disable */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="home"
          transform="translate(-36.000000, -149.000000)"
          stroke="#34C082"
        >
          <g id="Group-2" transform="translate(24.000000, 137.000000)">
            <g id="Group-9" transform="translate(12.000000, 12.000000)">
              <path
                d="M23.5,11.9986 C23.5,18.3496 18.351,23.4986 12,23.4986 C5.649,23.4986 0.5,18.3496 0.5,11.9986 C0.5,5.6476 5.649,0.4986 12,0.4986 C18.351,0.4986 23.5,5.6476 23.5,11.9986 L23.5,11.9986 Z"
                id="Stroke-1"
              ></path>
              <path
                d="M8.5,8.4986 C8.5,9.0506 8.052,9.4986 7.5,9.4986 C6.948,9.4986 6.5,9.0506 6.5,8.4986 C6.5,7.9466 6.948,7.4986 7.5,7.4986 C8.052,7.4986 8.5,7.9466 8.5,8.4986 L8.5,8.4986 Z"
                id="Stroke-3"
              ></path>
              <path
                d="M17.5,8.4986 C17.5,9.0506 17.052,9.4986 16.5,9.4986 C15.948,9.4986 15.5,9.0506 15.5,8.4986 C15.5,7.9466 15.948,7.4986 16.5,7.4986 C17.052,7.4986 17.5,7.9466 17.5,8.4986 L17.5,8.4986 Z"
                id="Stroke-5"
              ></path>
              <path
                d="M6.5286,15.4986 C7.6836,17.3006 9.7006,18.4986 11.9996,18.4986 C14.2996,18.4986 16.3156,17.3006 17.4716,15.4986 L6.5286,15.4986 Z"
                id="Stroke-7"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
